// *************************
// SVG Loader - https://github.com/iconic/SVGInjector
// *************************
var mySVGsToInject = document.querySelectorAll('svg[data-src]');
SVGInjector(mySVGsToInject);

// *************************
// MiniCart
// Add/edit/remove from cart using Fetch and the Shopify Cart API
// https://shopify.dev/api/ajax/reference/cart
// *************************

// add to cart listener
document.addEventListener('click', (event) => {
  const dataEl = event.target.closest('[data-add-to-cart]');
  if (dataEl) {
    //console.log('added to cart');
    event.preventDefault();

    // VALIDATION FOR VARIANTS
    // const variantSelectTitle = document.querySelector('[data-variant-select-title]').innerHTML.trim();

    // if(variantSelectTitle == 'Select your size'){
    //   dataEl.innerHTML = 'Select a size';
    // } else {
    //   dataEl.innerHTML = 'Add to bag';
    // }

    // Change button text and run animation
    if (dataEl.closest('.add-to-cart-button')) {
      dataEl.closest('.add-to-cart-button').querySelector('[data-btn-text]').innerHTML = 'Adding to Bag';
    } else {
      dataEl.parentElement.querySelector('[data-btn-text]').innerHTML = 'Adding to Bag';
    }
    dataEl.classList.add('active');
 
    // Add to cart
    setTimeout(function(){


      console.log(dataEl.dataset.variantId);

      // console.log('adding to bag...');
      // console.log(dataEl);
      // console.log(dataEl.leadTime);
     cartFetch('cart/add.js', dataEl.dataset.variantId || dataEl.dataset.productId, dataEl.dataset.productQty || 1, dataEl.dataset.properties || [], dataEl.dataset.leadTime || false);

       // If the item has a lead time, show the tooltip in the minicart
      // if(dataEl.dataset.leadTime){
      //   console.log('item contains lead item data');
      //   document.getElementById('show-cart-leadtime').classList.remove('hidden');
      // }
    
      setTimeout(function(){
        if (dataEl.closest('.add-to-cart-button')) {
            dataEl.closest('.add-to-cart-button').querySelector('[data-btn-text]').innerHTML = 'Add to Bag';
        } else {
          dataEl.parentElement.querySelector('[data-btn-text]').innerHTML = 'Add to Bag';
        }
        dataEl.parentElement.querySelector('[data-btn-text]').innerHTML = 'Add to Bag';
        dataEl.classList.remove('active');
      }, 500);
    }, 1000);
  }
});

// remove from cart listener
document.addEventListener('click', (event) => {
  const dataEl = event.target.closest('[data-remove-cart-item]');
  if (dataEl) {
    //console.log('remove');
    cartFetch('cart/change.js', dataEl.dataset.removeCartItem, 0, dataEl.dataset.properties || []);
  }

});

// Use the AJAX Cart URL to modify the cart data
function cartFetch(cartURL, id, quantity, properties, leadtime){
  //console.log(cartURL, id, quantity, properties, leadtime);

  let cartData = {
    id,
    quantity
  };

  //console.log('cartFetch');

  //console.log(properties);
  //console.log(leadtime);
  if(leadtime){
    // properties = 'lead time: extended delivery, test: 123';
    //properties = 'lead time:extended_delivery';
    properties = 'Lead time:This item may have an extended delivery time. A member of the Boodles team will be in touch to confirm the date of delivery with you.';
  }
  //console.log(cartData);

  if(properties.length) {
    let props = properties.split(",");
    let propsObj = {};

    for (let i = 0; i < props.length; i++) {
      let prop = props[i].split(":");
      propsObj[prop[0]] = prop[1];
    }

    cartData.properties = propsObj
  }

  // Use window.Shopify.routes to cover for international markets
  fetch(window.Shopify.routes.root + cartURL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(cartData)
  }).then((response) => {
    //console.log(response);
    getUpdatedCart();
  })
  .catch((error) => {
    //console.log(error);
    addToCartFail(error);
  });
}

// cart add/edit success, dispatch to minicart
function getUpdatedCart() {
  //console.log('get updated cart');
  var customEvent = new CustomEvent('toggle-minicart', {
    bubbles: true,
    cancelable: true,
    detail: { open: true }
  });
  window.dispatchEvent(customEvent);
}

// cart failure reporting
function addToCartFail(error){
  console.error('PROBLEM ADDING TO CART!', error); 
  var customEvent = new CustomEvent('show-msg', {
    detail: { 
      open: true,
      bgcolor: 'bg-red-500',
      textcolor: 'text-white',
      content: 'Sorry, there has been an error. Please try again later.'
    }
  });
  window.dispatchEvent(customEvent);
}

// *************************
// DeferredMedia for Product Media
// Ref - Dawn Theme
// *************************
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

// *************************
// Scroll to Anchor Function
// *************************
document.querySelectorAll('[data-scrollto]').forEach(item => {
  item.addEventListener('click', e => {
    e.preventDefault();
    const element = document.getElementById(e.target.getAttribute("data-scrollto"));
    //console.log(findPosition(element));
    window.scrollTo({ top: (findPosition(element) - document.getElementsByTagName('header')[0].offsetHeight), behavior: 'smooth' });
  });
});

function findPosition(obj) {
  var currenttop = 0;
  if (obj.offsetParent) {
    do {
      currenttop += obj.offsetTop;
    } while ((obj = obj.offsetParent));
    return [currenttop];
  }
}

// *************************
// Algolia
// *************************
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    const { html, state } = templateOptions;
    // Modify the header template if products
    if (resource == 'Products'){
    return html`
      <div class="aa-SourceHeader">
        <div class="aa-SourceHeaderTitle !flex justify-center">
          <a class="btn-secondary" href="/search?q=${encodeURIComponent(state.query)}">See all results for ${state.query}</a>
        </div>
        <div class="aa-SourceHeaderLine" />
      </div>
    `;
    // Otherwise use the default Algolia header
    } else {
      return html`
        <div class="aa-SourceHeader">
          <span class="aa-SourceHeaderTitle">
            ${algoliaShopify.translation_helpers.render_title(
              resource,
              state.query
            )}
          </span>
          <div class="aa-SourceHeaderLine" />
        </div>
    `;
    }
  });
});


document.addEventListener("DOMContentLoaded", function() {

  // *************************
  // Variant Dropdown for changing data on variant selection
  // - Based on the example on Shopify Dawn
  // *************************
  class VariantDropdown extends HTMLElement {
  
    constructor() {
      super();
      this.addEventListener('click', this.onVariantChange);
    }

    onVariantChange() {

      // if combined listingss product, then will have a URL
      // if this is a new URL then it is a new product
      // so fetch this product and update the page data and URL
      const url = this.dataset.url;
      const variantId = this.dataset.variant;
      if(url != window.location.pathname && url != '') {
        this.updateCombinedProduct(url, variantId);
      } else {

        this.updateOptions();
        this.updateMasterId();

        // Check if the variant was found
        if (!this.currentVariant) {
          console.log('no variant found')
        } else {
          this.updateURL();
          this.updateSKU();
          //this.updateTitle();
          this.renderProductInfo();
        }

      }

      
    }

    updateCombinedProduct(url, variantId){
      
      fetch(`${url}${variantId ? `?variant=${variantId}` : ''}`)
        .then((response) => response.text())
        .then((responseText) => {
          this.pendingRequestUrl = null;
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          const gallery = html.getElementById('pdp-content');
          document.getElementById('pdp-content').innerHTML = gallery.innerHTML;
          //console.log(gallery);
          window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
          //callback(html);
          // console.log(html);
        })
        .then(() => {
          // set focus to last clicked option value
          //document.querySelector(`#${targetId}`)?.focus();
          // console.log('do something else');

          var customEvent = new CustomEvent('reload-swiper', {
            bubbles: true,
            cancelable: true
          });
          window.dispatchEvent(customEvent);
          
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          } else {
            console.error(error);
          }
        });

    }

    updateOptions() {

      // Format to replace any "/" with "\/" to match regex in product json
      // Especially important for Ring Sizes with "/" -  do not remove!
      let variantTitleFormatted = this.dataset.value.replace(/\//g, "\/");

      if (variantTitleFormatted.includes(' / ')) {
        variantTitleFormatted = variantTitleFormatted.split(' / ').pop();
      }

      // Push the options through so we can cycle through the product json to find matching variant data
      const optionsArr = [];
      optionsArr.push(variantTitleFormatted);
      this.options = optionsArr;

      console.log(optionsArr);
    }
  
    updateMasterId() {


      this.currentVariant = this.getVariantData().find(item => item.options.includes(this.options[0]));

      // this.currentVariant = this.getVariantData().find((variant) => {
      //   return !variant.options.map((option, index) => {
      //     return this.options[index] === option;
      //   }).includes(false);
      // });
    }

    updateTitle() {
      document.querySelector('[data-variant-select-title]').innerHTML = this.currentVariant.title
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateSKU() {
      if (!this.currentVariant) return;
      document.getElementById('enquiry-sku').value = `${this.currentVariant.sku}`;
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(document.getElementById('variantData').textContent);
      return this.variantData;
    }

    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        //console.log(responseText);
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        
        const gallery = html.getElementById('pdp-content');
        document.getElementById('pdp-content').innerHTML = gallery.innerHTML;
        
        var customEvent = new CustomEvent('reload-swiper', {
          bubbles: true,
          cancelable: true
        });
        window.dispatchEvent(customEvent);

        return;
          
        // Update Price in DOM
        const priceId = `price-${this.dataset.section}`;
        const priceSrc = html.getElementById(priceId);
        const priceDest = document.getElementById(priceId);
        if (priceSrc && priceDest) priceDest.innerHTML = priceSrc.innerHTML;

        // unfilter gallery thumbs
        const thumbs = document.querySelectorAll('[data-swiper-thumb]');

        // set hidden status
        let swiperindex = 0;
        for (let i = 0; i < thumbs.length; i++) {
          if(thumbs[i].dataset.variant==this.currentVariant.title || thumbs[i].dataset.variant=='') {
            thumbs[i].dataset.swiperThumbHidden = false;
            thumbs[i].dataset.swiperIndex = swiperindex;
            swiperindex ++;
          } else {
            thumbs[i].dataset.swiperThumbHidden = true;
          }
        }

        // unfilter gallery Images
        const images = document.querySelectorAll('[data-product-slideshow-image]');

        console.log('update images', images);

        // set hidden status
        swiperindex = 0;
        // set default slide to
        let slideTo = 0;
        for (let i = 0; i < images.length; i++) {

          console.log(images[i].dataset.variant);

          if(images[i].dataset.variant==this.currentVariant.title) {
            images[i].dataset.swiperImageHidden = false;
            images[i].dataset.swiperIndex = swiperindex;
            if(this.currentVariant.featured_image){
              if(images[i].dataset.mediaId==this.currentVariant.featured_media.id){
                slideTo=swiperindex;
              }
            }
            swiperindex ++;
            document.querySelector('[data-product-slideshow]').swiper.slideTo(i-1);
          } else {
            images[i].dataset.swiperImageHidden = true;
          }
        }

      images.forEach(function(image) {        
        document.querySelectorAll('[data-bullet-index]').forEach(function(bullet){
          bullet.style.display="none";
        });
        var elementIndex = image.getAttribute('data-swiper-image-hidden');
        if (elementIndex === 'false') {
          var indexElement = image.getAttribute('data-swiper-slide-index');
          setTimeout(function(){
            document.querySelector('[data-bullet-index="' +indexElement + '"]').style.display="inline-block";
          }, 200);
        }
      });

        // unfilter modal gallery thumbs
        const modal_thumbs = document.querySelectorAll('[data-swiper-modal-thumb]');

        // set hidden status
        swiperindex = 0;
        for (let i = 0; i < modal_thumbs.length; i++) {
          if(modal_thumbs[i].dataset.variant==this.currentVariant.title || modal_thumbs[i].dataset.variant=='') {
            modal_thumbs[i].dataset.swiperModalThumbHidden = false;
            modal_thumbs[i].dataset.swiperIndex = swiperindex;
            swiperindex ++;
          } else {
            modal_thumbs[i].dataset.swiperModalThumbHidden = true;
          }
        }

        // unfilter modal gallery thumbs
        const modal_images = document.querySelectorAll('[data-product-modal-slideshow-image]');

        // set hidden status
        swiperindex = 0;
        for (let i = 0; i < modal_images.length; i++) {
          if(modal_images[i].dataset.variant==this.currentVariant.title || modal_images[i].dataset.variant=='') {
            modal_images[i].dataset.swiperModalImageHidden = false;
            modal_images[i].dataset.swiperIndex = swiperindex;
            swiperindex ++;
             // go to selected slide
            document.querySelector('[data-modal-slideshow]').swiper.slideTo(i-1);
          } else {
            modal_images[i].dataset.swiperModalImageHidden = true;
          }
        }

      });
    }

  }

  customElements.define('variant-dropdown', VariantDropdown);

  initPdpCardCarousels();

});

const initPdpCardCarousels = () => {
  const pdpCardCarousels = document.querySelectorAll('[data-pdp-card-carousel]');

  pdpCardCarousels.forEach(function(carousel) {

    var swiper = new Swiper(carousel, {
      slidesPerView: 1,
      navigation: {
        nextEl: carousel.querySelector('[data-pdp-card-carousel-next]'),
        prevEl: carousel.querySelector('[data-pdp-card-carousel-prev]')
      },
      pagination: {
        el: carousel.querySelector('[data-pdp-card-carousel-pagination]')
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", function() {
  initPdpCardCarousels();
});

// *************************
 //  Market Switcher - Used in Header / Burger Nav
 // *************************
 const marketSwitcher = document.querySelectorAll('[data-market-switcher]');
 const currentUrlSplit = window.location.href.split('/');
 let newUrl = '';
 
 const switchMarket = (el) => {
   currentUrlSplit[3].includes('en-') ? currentUrlSplit.splice(3, 1) : null;
   newUrl = el.target.value.length ? `${currentUrlSplit[0]}/${currentUrlSplit[1]}/${currentUrlSplit[2]}/${el.target.value}/${currentUrlSplit.slice(3).join('/')}` : `${currentUrlSplit[0]}/${currentUrlSplit[1]}/${currentUrlSplit[2]}/${currentUrlSplit.slice(3).join('/')}`;
   window.location.href = newUrl;
 }
 
 document.addEventListener("DOMContentLoaded", () => {
   marketSwitcher.forEach(switcher => {
     currentUrlSplit[3].includes('en-') ? switcher.value = currentUrlSplit[3] : null;
     switcher.classList.remove('hidden');
     switcher.addEventListener("change", switchMarket);
   });
 });
 
// *************************
//  Lazyload Videos
// *************************
document.addEventListener('DOMContentLoaded', function() {
  const lazyVideos = document.querySelectorAll('.lazy-video');
  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const source = video.querySelector('source');
          if (source) {
            source.src = source.getAttribute('data-src');
            video.load();
            if (video.hasAttribute('data-poster')) {
              video.poster = video.getAttribute('data-poster');
            }
            observer.unobserve(video);
          }
        }
      });
    });
    lazyVideos.forEach(video => {
      videoObserver.observe(video);
    });
  }
});